var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinchClamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 278.5000008197962,
    y: 253.99999918020382,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    d: "m57.7,48.3l-35.4,0c-4.5,0 -8.2,-3.7 -8.2,-8.2l0,0c0,-4.5 3.7,-8.2 8.2,-8.2l35.4,0c4.5,0 8.2,3.7 8.2,8.2l0,0c0,4.6 -3.7,8.2 -8.2,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    d: "m57.7,31.9c0.4,0 0.8,0 1.2,0.1l-23.4,-11.9c-1.4,-0.7 -3.1,-0.1 -3.8,1.2l-1.7,3.4c-1.1,2.3 -1.2,4.8 -0.5,7c0,0.1 0.2,0.2 0.3,0.2l27.9,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinchClamp);
export default __webpack_public_path__ + "static/media/pinchClamp.1a8349e238b3a1b2596d9c869a8384d5.svg";
export { ForwardRef as ReactComponent };